import { createAction } from 'redux-act';
import { IStartWatermarksProcessingAction } from '../types/watermarks';
import { IWatermarksProcessState } from '../reducers/watermarks';

export const startWaterMarkProcessing = createAction<IStartWatermarksProcessingAction>();
export const updateWatermarkProcessed = createAction<IWatermarksProcessState>();
